module.exports = __webpack_public_path__ + "static/media/contentExample3.888c8597.png";